// @ts-nocheck
import { sendRequestAQuote } from "@store/Framework/Services/RequestAQuoteService";
import {
    RequestAQuoteModel,
    RequestAQuoteRequestApiParamater,
} from "@store/Framework/Store/Bunzl/Components/RequestAQuoteForm/RequestAQuoteFormTypes";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = ApiHandlerDiscreteParameter<
    RequestAQuoteModel & HasOnSuccess & HasOnError<string>,
    RequestAQuoteRequestApiParamater,
    ServiceResult<RequestAQuoteModel>
>;

export const RequestAQuoteBeginLoading: HandlerType = props => {
    props.dispatch({
        type: "Foundation/Components/RequestAQuote/BeginLoading" as any,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        fields: props.parameter,
    };
};

export const CallSendRequestAQuote: HandlerType = async props => {
    props.apiResult = await sendRequestAQuote(props.apiParameter);

    if (!props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult.errorMessage);
    } else {
        props.parameter.onSuccess?.();
    }
};

export const RequestAQuoteFinishLoading: HandlerType = props => {
    props.dispatch({
        type: "Foundation/Components/RequestAQuote/FinishLoading" as any,
    });
};

export const chain = [
    RequestAQuoteBeginLoading,
    PopulateApiParameter,
    CallSendRequestAQuote,
    RequestAQuoteFinishLoading,
];

const sendRequestQuoteForm = createHandlerChainRunner(chain, "SendRequestQuoteForm");
export default sendRequestQuoteForm;
